export default __webpack_public_path__ + "static/media/Europe.af3eb1a6.svg";